module.exports = __webpack_public_path__ + "img/emoji-smile.6fb2ae42.svg";